var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.597,
    height: 56.5,
    viewBox: "0 0 78.597 56.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Education_1_copy_3",
    "data-name": "Education_1 copy 3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64986",
    "data-name": "Path 64986",
    d: "M140.9,157.261a30,30,0,0,0-1.444-8.475l-.063-.188H139.2a71.574,71.574,0,0,0-32.958,5.9c11.363-6.906,20.465-8.538,31.514-8.914h.377l-.188-.314a29.938,29.938,0,0,0-5.022-7.345l-.126-.126-.126.063a78.978,78.978,0,0,0-29.505,17.578,2.276,2.276,0,0,1-3.139,0,78.978,78.978,0,0,0-29.505-17.578L70.4,137.8l-.126.126a35.454,35.454,0,0,0-5.022,7.345l-.188.314h.377c10.986.377,20.151,2.072,31.514,8.914a71.574,71.574,0,0,0-32.958-5.9h-.188l-.063.188a26.128,26.128,0,0,0-1.444,8.475v.251h.251a66.2,66.2,0,0,0,14.376-1.318c6.529-1.067,12.681-2.072,19.712-.314a1.15,1.15,0,0,1,.879,1.13.992.992,0,0,0,1,1h6.152a.992.992,0,0,0,1-1,1.206,1.206,0,0,1,.879-1.13c7.031-1.758,13.183-.753,19.712.314a70.78,70.78,0,0,0,14.376,1.318h.251Z",
    transform: "translate(-62.3 -101.515)",
    fill: "#78a574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64987",
    "data-name": "Path 64987",
    d: "M87.839,107.936a76.906,76.906,0,0,1,18.017,9.668,75.452,75.452,0,0,1,17.954-9.668V98.959a1.661,1.661,0,0,0-.816-1.444c-2.009-1.193-7.408-3.076-17.138-3.076-7.973,0-13.058,1.256-15.694,2.386,3.139-2.009,10.044-3.39,18.268-3.39,11.237,0,16.824,1.758,16.824,5.085v2.637l12.995-6.089L105.793,80,73.4,95.067l14.376,6.654v6.215Z",
    transform: "translate(-66.432 -80)",
    fill: "#78a574"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileLogo4);
export default __webpack_public_path__ + "static/media/tile-logo4.82a0f44cac7934c8ff54143ec4d41c4f.svg";
export { ForwardRef as ReactComponent };